import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { PATHS } from '../common/constants';
import Suite from '../pages/Suite';
import Asset from '../pages/Asset';
import ServiceRequest from '../pages/ServiceRequest';
import Settings from '../pages/Settings/Settings';
import ViewImage from '../pages/ViewImage';
import InboxContainer from '../pages/Inbox/InboxContainer';
import Request from '../pages/Request/Request';
import KeyPickupView from 'src/pages/Suite/KeyPickupView/KeyPickupView';
import StrataManagerSuites from 'src/pages/StrataManagerSuites/StrataManagerSuites';

const StrataManagerRoutes = () => {
  return (
    <Switch>
      <Route path={PATHS.SETTINGS} component={Settings} />
      <Route path={PATHS.ASSETS_VIEW} component={Asset} />
      <Route path={PATHS.SERVICE_REQUESTS_VIEW} component={ServiceRequest} />
      <Route path={PATHS.SUITES_VIEW} component={Suite} />
      <Route path={PATHS.KEY_PICKUP_VIEW} component={KeyPickupView} />
      <Route path={PATHS.VIEW_IMAGE} component={ViewImage} />
      <Route path={PATHS.INBOX} component={InboxContainer} />
      <Route path={PATHS.REQUEST} component={Request} />
      <Route exact path={PATHS.PROPERTIES_LIST} component={StrataManagerSuites} />
      <Route path="/">
        <Redirect to={PATHS.PROPERTIES_LIST} />
      </Route>
    </Switch>
  );
};

export default StrataManagerRoutes;